<template>
  <span v-if="workingReward">
    <v-row class="mt-8">
      <v-col cols="12">
        <v-text-field
          label="Cash Back Rate"
          v-model="workingReward.cashBackRate"
          type="number"
          hint="Ex. 2.2"
          suffix="%"
          hide-spin-buttons
          dense
          :rules="requiredAndPositiveRule"
          @input="onChange"
          name="cashBackRate"
        />
      </v-col>
    </v-row>
    <v-row class="mt-6">
      <v-col cols="12">
        <v-text-field
          label="Purchase Limit"
          v-model="workingReward.purchaseLimit"
          type="number"
          hint="Ex. 3.00"
          prefix="$"
          hide-spin-buttons
          dense
          :rules="requiredAndPositiveRule"
          @input="onChange"
          name="purchaseLimit"
        />
      </v-col>
    </v-row>

    <v-row class="mt-6">
      <v-col cols="12">
        <v-radio-group
          label="POS Transaction Type"
          v-model="workingReward.transactionType"
          dense
          :rules="requiredRule"
          @change="onChange">
            <v-radio v-for="item in Object.entries(PosTransactionTypes)" v-bind:key="item.value" :value="item[1].value" :label="item[1].description" :ref="`${item[1].value}_Radio`"/>
        </v-radio-group>
      </v-col>
    </v-row>

    <v-row class="mt-6">
      <v-col cols="12" ref="calculatedCashBackLimit">
        Calculated Cash Back Limit: <strong>{{calculateCashBackLimit()}}</strong>
      </v-col>
    </v-row>

  </span>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { CashBackReward, PosTransactionTypes } from '@/api/product/levelrewards/rewards';
import { ValidationTool } from '@/util';

@Component
export default class CashBackRewardEditor extends Vue {
  @Prop()
  value!:CashBackReward;

  workingReward:CashBackReward | null = null;

  // Make visible to template
  PosTransactionTypes:any = PosTransactionTypes;

  requiredRule:Array<any> = [(value: any) => {
    if (value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    return true;
  }];

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  calculateCashBackLimit() : string {
    if (this.workingReward!.cashBackRate && this.workingReward!.purchaseLimit) {
      return `$${(this.workingReward!.purchaseLimit * this.workingReward!.cashBackRate / 100).toFixed(2)}`;
    }
    return '';
  }

  @Watch('value')
  initialize() {
    this.workingReward = this.value.clone() as CashBackReward;
  }

  onChange() {
    this.$emit('input', this.workingReward);
  }
}
</script>

<style lang="scss" scoped>
</style>
